function re2019() {


    if ( $('.isogrid').length ) {
        setTimeout(function(){

            $('.loading img').each(function(index){
                var el = $(this);
                el.attr('src', el.data('src'));
            });

            jQuery(function($) {
                $('.loading img').on('load', function() {

                    var el = $(this);

                    setTimeout(function() {
                        el.parent().removeClass('loading');
                        el.prev().fadeOut(300);
                    }, _.random (100, 600) );

                    setTimeout(function() {
                        el.prev().remove();
                    }, 3000);

                });
            });


        }, 1000);
    }

    if ( $('#concierge').length ) {
        if(window.location.hash) {
            var active = window.location.hash.slice(6);
            $(`#date option[data-week="${active}"]`).prop('selected', true);
        }
    }

    if ( $('.re19-weeks').length ) {

        $('.re19-weeks a.view-lineup').on('click', function(){
            var el = $(this);
            if ( el.hasClass('active') ) {
                el.parent().removeClass('active');
                el.next('.rlineup').stop(true,false).slideUp(400, 'easeInOutExpo');
                el.removeClass('active');
                el.find('.icon').removeClass('fas fa-chevron-up').addClass('fat fa-chevron-down');
            } else {
                el.parent().addClass('active');
                el.next('.rlineup').stop(true,false).slideDown(400, 'easeInOutExpo');
                el.addClass('active');
                el.find('.icon').removeClass('fat fa-chevron-down').addClass('fas fa-chevron-up');
            }
        });


        $('a.startgal, a.startvid').on('click', function(e){
            var el = $(this);
            e.preventDefault();
            var dest = el.data('target');
            log(dest);
            $('a[data-fancybox="'+dest+'"]:first').trigger('click');
        });

    }

    $('.teaser .vid-cover').on('click', function(){
        var el = $(this);
        var vidlink = el.parent().find('iframe').data('src');
        el.parent().find('iframe').attr('src', vidlink);
        el.fadeOut(300);
    });

    $('.bgaccent.preload').removeClass('preload');

    setTimeout(function() {
        $('.rloader').fadeOut(600);
    }, 1500);
    setTimeout(function(){
        $('.seeker.preload').removeClass('preload');
    }, 1500);

    var endtime = $('#recounter').data('target');
    var time = moment.tz(endtime,'America/New_York');
    time = time.toDate();

    var recountdown = $('#recounter');

    recountdown.countdown(time, function(event){

        var format = '<ul>\
        <li class="days">\
        <span class="ticker">%D</span>\
        <span class="label">Days</span>\
        </li>\
        <li class="hours">\
        <span class="ticker">%H</span>\
        <span class="label">Hours</span>\
        </li>\
        <li class="minutes">\
        <span class="ticker">%M</span>\
        <span class="label">Minutes</span>\
        </li>\
        <li class="seconds">\
        <span class="ticker">%S</span>\
        <span class="label">Seconds</span>\
        </li></ul>';

        var thetime = event.strftime(format);

        var calctime = event.strftime("%H:%M:%S");

        if(calctime != '00:00:00') {

            $(this).html(' '+ thetime );

        } else {

            $(this).html(' '+ thetime );
        }

    });


    if ( ! $('.re19-home').length ) {
        return;
    }

    $('.start, img, input, button, p').each(function(index) {

        var el = $(this);
        setTimeout(function() {
            el.fadeTo( _.random(500, 800), 1);
        }, _.random(500, 2100));

    });

    setTimeout(function() {
        $('.rloader').fadeOut(600);
    }, 1400);


    subscribe();

    function subscribe() {

        var cform = $('#signup');

        if(!cform.length) {
            return;
        }

        cform.on('submit', function(e) {

            e.preventDefault();

        }).validate({
            submitHandler: function() {

                cform.find('button')
                .attr('disabled', true);
                subscribePost();

            }

        });

    }


    function subscribePost() {

        var cform = $('#signup');

        var dataString = cform.serialize();

        $.ajax({
            type: 'POST',
            url: window.location.href,
            data: dataString,
            dataType: 'html text'
        }).done(function(data){

            cform.fadeTo(300,0);
            cform.slideUp(300);

            cform.before('<div class="success" style="display: none;">Request Received</div>');
            $('.success').slideDown(300);

        }).fail(function(xhr, ajaxOptions, thrownError){
            var errortext = xhr.responseText;

            errortext = errortext.replace('"','');
            errortext = errortext.replace('"','');

            $('li.emailaddy').find('input').addClass('error');
            $('li.emailaddy').find('label').fadeIn(300);
            $('label#contact_email-error').remove();
            $('li.emailaddy').append(`<label id="contact_email-error" class="error" for="contact_email">${errortext}</label>`);

            cform.find('button')
            .attr('disabled', false);


        });

    }

}


function re2018post() {

    var cform = $('#re18signup');
    var dataString = cform.serialize();

    $.ajax({
        type: 'POST',
        url: '',
        data: dataString,
        dataType: 'html text'
    }).done(function(data){

        cform.find('button')
        .attr('disabled', false)
        .removeClass('working');

        cform.find('label.error').text('Success');
        cform.find('div').fadeTo(300,0);
        setTimeout(function(){
            cform.find('div').css({'top':'-10000px', 'position':'relative'});
            cform.append('<div class="success">EMAIL ACCEPTED. AWAIT OUR NEXT TRANSMISSION.</div>');
            cform.find('div.success').fadeTo(300,1);
        }, 300);


    }).fail(function(xhr, ajaxOptions, thrownError){
        var errortext = xhr.responseText;

        cform.find('.emailaddy').append('<label id="contact_email-error" class="error">Invalid Email Address</label>').fadeTo(300,1);


        setTimeout(function(){
            cform.find('button')
            .attr('disabled', false)
            .removeClass('working');
        }, 300);

    });

}
function rebiza18() {

    setTimeout(function () {
        $('.seeker-anim').fadeIn(300);
    }, 1000);

    if (!!$('.re18vid').length) {
        $('.re18vid').trigger('click');
    }

    var cform = $('#re18signup');

    cform.on('submit', function (e) {
        e.preventDefault();
    }).validate({
        submitHandler: function () {
            cform.find('button')
                .attr('disabled', true)
                .addClass('working');
            re2018post();
        }
    });


    setTimeout(function () {
        $('#rebiza18').fadeTo(500, 1);
    }, 1000);

    if (!$('#rebiza-bg').length) {
        return;
    }

    setTimeout(function () {
        $('#rebiza-bg').fadeTo(500, 1);
    }, 3000);

    var c = document.getElementById("c");
    var ctx = c.getContext("2d");

    //making the canvas full screen
    c.height = window.innerHeight;
    c.width = window.innerWidth;

    //chinese characters - taken from the unicode charset
    //var chinese = "田由甲申甴电甶男甸甹町画甼甽甾甿畀畁畂畃畄畅畆畇畈畉畊畋界畍畎畏畐畑";
    var chinese = '022818';
    //converting the string into an array of single characters
    chinese = chinese.split("");

    var font_size = 10;
    var columns = c.width / font_size; //number of columns for the rain
    //an array of drops - one per column
    var drops = [];
    //x below is the x coordinate
    //1 = y co-ordinate of the drop(same for every drop initially)
    for (var x = 0; x < columns; x++) {
        drops[x] = 1;
    }

    //drawing the characters
    function draw() {
        //Black BG for the canvas
        //translucent BG to show trail
        ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
        ctx.fillRect(0, 0, c.width, c.height);

        ctx.fillStyle = "#3b65c1"; //green text
        ctx.font = font_size + "px arial";
        //looping over drops
        for (var i = 0; i < drops.length; i++) {
            //a random chinese character to print
            var text = chinese[Math.floor(Math.random() * chinese.length)];
            //x = i*font_size, y = value of drops[i]*font_size
            ctx.fillText(text, i * font_size, drops[i] * font_size);

            //sending the drop back to the top randomly after it has crossed
            // the screen adding a randomness to the reset to make the drops
            // scattered on the Y axis
            if (drops[i] * font_size > c.height && Math.random() > 0.975) {
                drops[i] = 0;
            }

            //incrementing Y coordinate
            drops[i]++;
        }
    }

    setInterval(draw, 33);
}

var matrixanim = null;
$(window).on('resize', function () {
    clearTimeout(matrixanim);
    matrixanim = setTimeout(function () {
        //resetMatrix();
    }, 100);
});

function resetMatrix() {

    //$('#rebiza-bg').fadeTo(10,0);
    //$('#rebiza-bg').html('<canvas id="c"></canvas>');
    matrix();
}
